<template>
  <v-card :outlined="outlined" flat>
    <Header
      title="Personal Information"
      subtitle="Enter the personal details of the customer"
    />

    <ValidationObserver ref="observer">
      <v-row dense class="mt-5">
        <v-col v-if="!personDetailsOnly" cols="6" sm="4">
          <!-- <ValidationProvider
            name="Person Class"
            rules="required"
            events="['blur']"
            v-slot="{ errors }"
          >
            <v-select
              dense
              :items="personClasses"
              item-text="text"
              item-value="value"
              outlined
              :readonly="isIntegrated"
              label="Person Class"
              :error-messages="errors"
              v-model="details.personClass"
            >
              <template v-slot:label>
                Person Class
                <span class="red--text">*</span>
              </template>
            </v-select>
          </ValidationProvider> -->
        </v-col>
        <v-col cols="6" :sm="personDetailsOnly ? 6 : 4">
          <ValidationProvider
            name="Tax Number"
            rules="min:9|max:14|unique_trn_check"
            events="['blur']"
            v-slot="{ errors }"
          >
            <v-text-field
              dense
              outlined
              :readonly="isIntegrated"
              :error-messages="errors"
              v-model="details.trn"
            >
              <template v-slot:label>
                Tax Number
                <span class="red--text">*</span>
              </template>
            </v-text-field>
          </ValidationProvider>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <ValidationProvider
            name="First Name"
            rules="required"
            events="['blur']"
            v-slot="{ errors }"
          >
            <v-text-field
              dense
              outlined
              label="First Name"
              :error-messages="errors"
              v-model="details.firstName"
            >
              <template v-slot:label>
                First Name
                <span class="red--text">*</span>
              </template>
            </v-text-field>
          </ValidationProvider>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <ValidationProvider
            name="Last Name"
            rules="required"
            events="['blur']"
            v-slot="{ errors }"
          >
            <v-text-field
              dense
              outlined
              label="Last Name"
              :error-messages="errors"
              v-model="details.lastName"
            >
              <template v-slot:label>
                Last Name
                <span class="red--text">*</span>
              </template>
            </v-text-field>
          </ValidationProvider>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-text-field
            dense
            outlined
            label="Middle Name"
            v-model="details.middleName"
          >
          </v-text-field>
        </v-col>
        <v-col cols="12" sm="6">
          <ValidationProvider
            name="Alias"
            rules="max:25"
            events="['blur']"
            v-slot="{ errors }"
          >
            <v-text-field
              dense
              outlined
              label="Alias"
              :error-messages="errors"
              v-model="details.alias"
            ></v-text-field>
          </ValidationProvider>
        </v-col>
        <v-col cols="12" sm="6">
          <ValidationProvider
            name="Gender"
            rules="required"
            events="['blur']"
            v-slot="{ errors }"
          >
            <v-select
              dense
              :items="['Male', 'Female']"
              outlined
              label="Gender"
              :error-messages="errors"
              v-model="details.gender"
            >
              <template v-slot:label>
                Gender
                <span class="red--text">*</span>
              </template>
            </v-select>
          </ValidationProvider>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <ValidationProvider
            name="DOB"
            rules="required"
            events="['blur']"
            v-slot="{ errors }"
          >
            <v-text-field
              dense
              type="date"
              outlined
              label="DOB"
              :error-messages="errors"
              v-model="details.dateOfBirth"
            >
              <template v-slot:label>
                Date of Birth
                <span class="red--text">*</span>
              </template>
            </v-text-field>
          </ValidationProvider>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <ValidationProvider
            name="Title"
            rules="max:120"
            events="['blur']"
            v-slot="{ errors }"
          >
            <v-text-field
              dense
              outlined
              label="Title"
              :error-messages="errors"
              v-model="details.title"
            >
            </v-text-field>
          </ValidationProvider>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <ValidationProvider
            name="Marital Status"
            events="['blur']"
            v-slot="{ errors }"
          >
            <v-select
              :items="maritalStatuses"
              dense
              outlined
              label="Marital Status"
              :error-messages="errors"
              v-model="details.maritalStatus"
            >
              <template v-slot:label>
                Marital Status
                <span class="red--text">*</span>
              </template>
            </v-select>
          </ValidationProvider>
        </v-col>
        <v-col cols="12" :sm="personDetailsOnly ? 4 : 4">
          <ValidationProvider
            name="Email"
            rules="email"
            events="['blur']"
            v-slot="{ errors }"
          >
            <v-text-field
              dense
              type="email"
              outlined
              label="Email"
              :error-messages="errors"
              v-model="details.emailAddress"
            ></v-text-field>
          </ValidationProvider>
        </v-col>
        <v-col v-if="!personDetailsOnly" cols="12" sm="4">
          <ValidationProvider
            name="Date of Membership"
            :rules="`required|date|date_less_than:${yesterday}`"
            events="['blur']"
            v-slot="{ errors }"
          >
            <v-text-field
              dense
              outlined
              type="date"
              label="Date of Membership"
              :error-messages="errors"
              v-model="details.dateOfMembership"
            >
              <template v-slot:label>
                Date of Membership
                <span class="red--text">*</span>
              </template>
            </v-text-field>
          </ValidationProvider>
        </v-col>
      </v-row>
    </ValidationObserver>
  </v-card>
</template>

<script>
import pageMixin from '@/mixins/page.mixin';
import { yesterday } from '@/lib/helpers';
import Header from './Header.vue';
import { extend } from 'vee-validate';

import AccountManagementService from '@/modules/loanpro/services/account-management.service';
const accountManagementService = new AccountManagementService();

export default {
  components: {
    Header
  },
  props: {
    outlined: {
      type: Boolean,
      default: true
    },

    isIntegrated: {
      type: Boolean,
      default: false
    },
    account: {
      type: Object,
      default: () => ({})
    },
    personDetailsOnly: {
      type: Boolean,
      default: false
    }
  },
  mixins: [pageMixin],
  data() {
    return {
      yesterday: yesterday(),
      maritalStatuses: [
        'Single',
        'Married',
        'Widowed',
        'Divorced',
        'Separated '
      ],
      personClasses: [
        { text: 'Primary', value: 'primary' },
        { text: 'Secondary', value: 'secondary' }
      ],
      details: this.account
    };
  },

  mounted() {
    extend('unique_trn_check', {
      validate: async (value) => {
        const result = await accountManagementService.doesTRNExist(
          this.details.id,
          value
        );
        if (!result) {
          return true;
        }

        return {
          valid: false
        };
      },
      message: 'This trn already exist for another person.'
    });
  },

  watch: {
    details: {
      async handler() {
        await this.validateData();
      },
      deep: true
    }
  },

  emits: ['update'],

  methods: {
    setDetails(info) {
      if (info?.dateOfBirth) {
        info.dateOfBirth = info.dateOfBirth.split('T')?.[0];
      }
      this.details = info;
    },
    async validateData() {
      return await this.$refs.observer.validate();
    },
    async submit() {
      const valid = await this.$refs.observer.validate();
      if (!valid)
        return this.showSnack({
          color: 'error',
          title: `Invalid data`,
          message: 'Please check the form for errors'
        });
      this.$emit('update', this.details);
    }
  }
};
</script>
